import React, { useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { TriStateCheckbox } from 'primereact/tristatecheckbox'
import { Button } from 'primereact/button'

export default function AdvancedSearchBar(props) {

    const [fields, setFields] = useState(props.config.advFields)

    const handleValueChange = (index, newValue) => {
        const newFields = [...fields]
        newFields[index].value = newValue
        setFields(newFields)
    }

    return (

        <div className={`border-1 mb-2 p-2 border-100 surface-ground  ${props.barClassName}`} >

            <div className="formgrid grid p-fluid mt-0">

                {fields.map((field, index) => {
                    return (
                        <div key={field.name} className='field col-12 md:col-4 lg:col-3 xl:col-2 mb-2'>
                            {(field.component === 'InputText') &&
                                <InputText
                                    id={field.name}
                                    className='p-inputtext-sm'
                                    value={field.value ? field.value : ''}
                                    onChange={(e) => handleValueChange(index, e.target.value)}
                                    placeholder={field.label}
                                    inputMode={field.inputMode}
                                    autoComplete='off'
                                    onKeyUp={data => {
                                        if (data.key === 'Enter') {
                                            props.config.searchType = 'adv'
                                            props.config.advFields = fields
                                            props.onSearchClick(props.config)

                                        }
                                    }}
                                />
                            }
                            {(field.component === 'TriStateCheckbox') &&
                                <div className='flex flex-row mt-1'>
                                    <label className="flex items-center">
                                        <TriStateCheckbox
                                            id={field.name}
                                            className='p-inputtext-sm'
                                            value={field.value}
                                            onChange={(e) => handleValueChange(index, e.target.value)}
                                        />
                                        <span className='ml-2 text-sm'>{field.label}</span>
                                    </label>
                                </div>
                            }
                        </div>

                    )
                })}

            </div>

            <div className='flex gap-2 justify-content-between'>

                <div>
                    <Button label="" severity="" icon='pi pi-eraser' text onClick={() => {
                        fields.map((e) => {
                            if (e.type === 'boolean') {
                                e.value = null
                            } else {
                                e.value = ''
                            }
                            return e
                        })
                        setFields([...fields])
                    }} />
                </div>
                <div className='flex gap-2'>


                    <Button id='btnAdvSearch' label="Pesquisar" icon="pi pi-search" severity="" onClick={_ => {
                        props.config.searchType = 'adv'
                        props.config.advFields = fields
                        props.onSearchClick(props.config)
                    }} />
                    <Button label="Fechar" severity="" icon='pi pi-times' onClick={() => {
                        props.onCloseClick()
                    }} />
                </div>

            </div>

        </div >
    )
}

